import { Directive, ElementRef, AfterViewInit, Input } from '@angular/core';
import { SwiperOptions } from 'swiper/types';

@Directive({
  selector: '[appSwiperExtension]',
  standalone: true,
})
export class SwiperExtensionDirective {
  @Input() swiperInstance!: any; // The swiper instance input
  @Input() swiperConfig!: SwiperOptions; // The swiper config input
  @Input() items!: any;
  @Input() type = 'curved';

  private swiperContainer: any;

  private typeToFunctionMap: any = {
    curved: this.applyCurvedEffect.bind(this),
  };

  constructor(private el: ElementRef) {
    this.swiperContainer = el.nativeElement;
  }

  ngOnChanges(): void {
    if (this.swiperInstance) {
      const functionToCall: any = this.typeToFunctionMap?.[this.type];
      setTimeout(() => {
        functionToCall();
      }, 0);

      // Update the curve effect when the slide changes
      this.swiperInstance.on('slideChange', () => {
        functionToCall();
      });

      // Update the curve effect when the resize
      this.swiperInstance.on('resize', () => {
        functionToCall();
      });
    }
  }

  applyCurvedEffect() {
    const slides = this.swiperContainer.querySelectorAll('swiper-slide');
    const slidesPerView = this.swiperInstance.params.slidesPerView;
    const totalSlides = slides.length;
    const centerIndex =
      totalSlides >= slidesPerView
        ? (slidesPerView - 1) / 2
        : (totalSlides - 1) / 2; // Calculate the center based on visible slides

    slides.forEach((slide: HTMLElement, index: number) => {
      const slideOffset = index - this.swiperInstance.activeIndex;

      const slideCenterOffset = slideOffset - centerIndex;

      // For the center element (no transformation)
      if (slideCenterOffset === 0 || totalSlides < slidesPerView) {
        slide.style.transition = 'all 0.6s ease'; // Smooth transition
        slide.style.transform = 'translate(0px, 0px)'; // No transformation for the center slide
        slide.style.transformOrigin = 'center';
        return;
      }

      const offsetFactor = Math.abs(slideCenterOffset); // The farther the slide is from the center, the greater the effect

      // Calculate the translate and rotate values based on the distance from the center
      const translateY = offsetFactor > 1 ? 20 * offsetFactor : 8; // Adjust translation in Y
      const rotateDeg = 5.1 * slideCenterOffset; // Rotate based on the slide's offset

      const transformOrigin = slideCenterOffset > 0 ? 'left top' : 'right top';

      // Apply the transformation to the slide
      slide.style.transition = 'all 0.6s ease';
      slide.style.transform = `translate(0px, ${translateY}px) rotate(${rotateDeg}deg)`;
      slide.style.paddingBottom = `${15 * (slidesPerView - 1)}px`;
      slide.style.transformOrigin = transformOrigin;
    });
  }
}
